const createCustomLabelsPlugin = ({ leftPadding = 40, role = false, sellerLabel = 'Seller', maxNameChars = 60 } = {}) => {
  return {
    id: 'custom-y-labels-2lines',
    afterDatasetsDraw: (chart) => {
      const { ctx } = chart;
      const datasetMeta = chart.getDatasetMeta(0);
      if (!datasetMeta || !datasetMeta.data) return;

      ctx.save();
      ctx.textBaseline = 'middle';

      const nameFontSize = 16;
      const roleFontSize = 14;
      const nameFont = `400 ${nameFontSize}px Arial, Helvetica, sans-serif`;
      const roleFont = `400 ${roleFontSize}px Arial, Helvetica, sans-serif`;
      const nameColor = '#1F3354';
      const roleColor = '#9D9D9D';
      const leftX = 8;
      const lineGap = 4;

      // maximum text width for rendering (with reserve)
      const maxTextWidth = Math.max(40, leftPadding - 16);

      datasetMeta.data.forEach((barEl, index) => {
        const yCenter = barEl.y;
        const rawLabel = chart.data.labels[index];

        // rawLabel is expected as an object { fullName, role, displayName } when the plugin is used.

        let fullName = '';
        let roleText = '';
        if (rawLabel && typeof rawLabel === 'object') {
          fullName = rawLabel.fullName || rawLabel.displayName || String(rawLabel || '');
          roleText = rawLabel.role || rawLabel.subtitle || '';
        } else {
          fullName = String(rawLabel || '');
        }

        if (!roleText) roleText = sellerLabel || '';

        // We decide whether to draw the second line
        const shouldDrawRole = Boolean(role) && Boolean(roleText && String(roleText).trim());

        // Vertical coordinates
        let nameY, roleY;
        if (shouldDrawRole) {
          const totalHeight = nameFontSize + lineGap + roleFontSize;
          nameY = yCenter - (totalHeight / 2) + nameFontSize / 2;
          roleY = nameY + nameFontSize / 2 + lineGap + roleFontSize / 2;
        } else {
          nameY = yCenter;
          roleY = null;
        }

        // trim long strings to avoid drawing extremely long text
        let nameToDraw = String(fullName || '');
        if (nameToDraw.length > maxNameChars) nameToDraw = `${nameToDraw.slice(0, maxNameChars)}...`;

        // draw name with truncation to fit maxTextWidth
        ctx.font = nameFont;
        ctx.fillStyle = nameColor;
        if (ctx.measureText(nameToDraw).width > maxTextWidth) {
          while (nameToDraw.length > 0 && ctx.measureText(nameToDraw + '...').width > maxTextWidth) {
            nameToDraw = nameToDraw.slice(0, -1);
          }
          nameToDraw = nameToDraw + '...';
        }
        ctx.fillText(nameToDraw, leftX, nameY);

        if (shouldDrawRole && roleY !== null) {
          let roleToDraw = String(roleText || '');
          if (ctx.measureText(roleToDraw).width > maxTextWidth) {
            while (roleToDraw.length > 0 && ctx.measureText(roleToDraw + '...').width > maxTextWidth) {
              roleToDraw = roleToDraw.slice(0, -1);
            }
            roleToDraw = roleToDraw + '...';
          }
          ctx.font = roleFont;
          ctx.fillStyle = roleColor;
          ctx.fillText(roleToDraw, leftX, roleY);
        }
      });

      ctx.restore();
    }
  };
};

export default createCustomLabelsPlugin;